"use client";

import { useSyncExternalStore } from "react";

function coarseMq() {
  return window.matchMedia("(pointer: coarse)");
}

/**
 * Phone WebViews treat native `title` as a tooltip on tap, so Download and
 * other icon buttons never fire click. Desktop hover labels stay.
 */
export function useCoarsePointer() {
  return useSyncExternalStore(
    (onStoreChange) => {
      const mq = coarseMq();
      mq.addEventListener("change", onStoreChange);
      return () => mq.removeEventListener("change", onStoreChange);
    },
    () => coarseMq().matches,
    () => false,
  );
}

export function iconButtonTitle(label: string | undefined): string | undefined {
  if (!label) return undefined;
  if (typeof window !== "undefined" && coarseMq().matches) return undefined;
  return label;
}

export function suppressMobileButtonTitles(target: EventTarget | null) {
  if (typeof window === "undefined" || !coarseMq().matches) return;
  if (!(target instanceof Element)) return;
  const el = target.closest("button[title], a[title], [role='button'][title]");
  if (el instanceof HTMLElement) el.removeAttribute("title");
}
